import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { layout, LayoutProps, space, SpaceProps } from 'styled-system';
import colors from '../lib/colors';
import { LabelOrLabelT } from './Button';

interface Props extends LayoutProps, SpaceProps {
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  css?: any;
}

// TODO we have two similiar comoponents
// BorderlessButton VS Button (variant="*-text")
// we should reduce them and make it simpler

const BorderlessButton = ({
  label,
  labelT,
  onClick,
  ...props
}: Props & LabelOrLabelT) => {
  const { t } = useTranslation();
  const buttonLabel = labelT ? t(labelT.key, labelT.defaultValue) : label;
  return (
    <StyledButton
      {...props}
      type="button"
      onClick={onClick}
      data-testid={labelT?.key}
    >
      {buttonLabel}
    </StyledButton>
  );
};

export default BorderlessButton;

const StyledButton = styled('button')`
  border: none;
  background: transparent;
  display: block;
  margin: 12px auto;
  font-weight: 500;
  letter-spacing: 0;
  color: ${colors.warning};
  font-size: 14px;
  text-align: center;
  outline: none;
  ${layout}
  ${space}
`;
